export default {
    predefineColors: [
        '#ffffff',
        '#000000',
        '#dddddd',
        '#ff0000',
        '#ff8c00',
        '#ffff00',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
    ]
}